function getChildBlocksOf(block) {
	const blocks = [];

	if (block.hasOwnProperty('blocks')) {
		blocks.push(block.blocks);
	}

	switch (block.type) {
		case 'carousel':
			blocks.push(block.data?.cards);
			break;
		case 'tabs':
			blocks.push(block.data?.tabs);
			break;
		case 'flashCard':
			blocks.push(block.data?.blocks);
			blocks.push(block.data?.overlays?.answer?.blocks);
			break;
		case 'flipCardEnhanced':
			blocks.push(block.data?.front?.blocks);
			blocks.push(block.data?.back?.blocks);
			break;
		case 'libraryContentCustom':
			blocks.push(block.data?.blocks);
			blocks.push(block.data?.overlays?.expanded?.blocks);
			break;
		case 'contentMultipleChoiceQuestion':
		case 'contentMultipleChoiceQuestionTemplate':
		case 'adaptiveLearningResult':
			blocks.push(block.data?.blocks);
			blocks.push(block.data?.overlays?.correct?.blocks);
			blocks.push(block.data?.overlays?.incorrect?.blocks);
			break;
	}

	const popup = block.actions?.find(action => action.type === 'popup');
	if (popup?.blocks) {
		blocks.push(popup.blocks);
	}

	return blocks.filter(Boolean);
}

export function deleteBlockFrom(blocks, id) {
	const indexFound = blocks.findIndex(block => block.id === id);

	if (indexFound > -1) {
		blocks.splice(indexFound, 1);
		return true;
	} else {
		for (const block of blocks) {
			const childBlocks = getChildBlocksOf(block);

			for (const childBlock of childBlocks) {
				if (deleteBlockFrom(childBlock, id)) {
					return true;
				}
			}
		}
	}
}
